export const MARKETING_HEADER_CHROME_PORTAL_ATTR =
	"data-marketing-header-chrome-portal";

const MARKETING_HEADER_CHROME_PORTAL_SELECTOR = `[${MARKETING_HEADER_CHROME_PORTAL_ATTR}]`;

function nodeInMarketingHeaderChrome(node: EventTarget | null): boolean {
	if (node == null || typeof document === "undefined") {
		return false;
	}
	if (!(node instanceof Node)) {
		return false;
	}
	const header = document.querySelector("[data-marketing-site-header]");
	if (header?.contains(node)) {
		return true;
	}
	if (node instanceof Element) {
		return node.closest(MARKETING_HEADER_CHROME_PORTAL_SELECTOR) != null;
	}
	return false;
}

interface DismissableOutsideEvent {
	preventDefault: () => void;
	detail?: {
		originalEvent?: Event;
	};
}

function interactionTargetsFromOutsideEvent(
	event: DismissableOutsideEvent,
	target: EventTarget | null,
): EventTarget[] {
	const targets: EventTarget[] = [];
	if (target != null) {
		targets.push(target);
	}
	const original = event.detail?.originalEvent;
	if (original instanceof FocusEvent && original.relatedTarget != null) {
		targets.push(original.relatedTarget);
	}
	if (typeof document !== "undefined" && document.activeElement != null) {
		targets.push(document.activeElement);
	}
	return targets;
}

function nodeInMarketingNavDismissShield(node: EventTarget | null): boolean {
	if (!(node instanceof Element)) {
		return false;
	}
	return node.closest("[data-sq-overlay-dismiss-shield]") != null;
}

/** Topic reading-pace slider (see `TopicReadingPaceSlider`); may render in a portal outside dialog content. */
function nodeInTopicReadingPaceChrome(node: EventTarget | null): boolean {
	if (!(node instanceof Element)) {
		return false;
	}
	return node.closest("[data-sq-topic-reading-pace]") != null;
}

/** Keep marketing navbar / banner clickable while a non-modal Radix layer is open. */
export function preventDismissWhenMarketingSiteHeaderTarget(
	event: DismissableOutsideEvent,
	target: EventTarget | null,
): void {
	for (const candidate of interactionTargetsFromOutsideEvent(event, target)) {
		if (
			nodeInMarketingHeaderChrome(candidate) ||
			nodeInMarketingNavDismissShield(candidate) ||
			nodeInTopicReadingPaceChrome(candidate)
		) {
			event.preventDefault();
			return;
		}
	}
}
